/* unplugin-vue-components disabled */import script from "./activityItem.vue?vue&type=script&setup=true&name=activityItem&lang=js"
export * from "./activityItem.vue?vue&type=script&setup=true&name=activityItem&lang=js"

import "./activityItem.vue?vue&type=style&index=0&id=23eb8bea&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23eb8bea"]])

export default __exports__